import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid-x client-home-view" }
const _hoisted_2 = { class: "cell small-12 large-8" }
const _hoisted_3 = { class: "cell small-12 large-4" }

import { NLayoutContent } from 'naive-ui'
import StartGuide from '@/components/client/home/StartGuide.vue'
import MeetOurTalent from '@/components/client/home/MeetOurTalent.vue'
import OurProcess from '@/components/client/home/OurProcess.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NLayoutContent), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(StartGuide),
          _createVNode(MeetOurTalent)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(OurProcess)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})